import apiUrl from "../../../constants";
import axios from "axios";
import Paginate from "vuejs-paginate";
import {
	Validator
} from "vee-validate";
import VueElementLoading from 'vue-element-loading';
import Pagination from './../shared/pagination'

export default {
	name: "role",
	components: {
		Paginate,
		Pagination,
		VueElementLoading
	},
	data: function() {
		return {
			totalRows:0,
			currentPage: 1,
			totalPage: 0,
			pageLimit:10,
			updaterolemodal: false,
			editrolemodal: false,
			addrolemodal: false,
			permissionFlag: false,
			roleaction: "",
			listRoleData: [],
			listPermissionData: [],
			permissionid: [],
			// pageno: 0,
			// totalPage: 0,
			rolename: "",
			perm_id: [],
			roleid: "",
			devicetype: '',
			isLoading: false,
			resultCount: '',
			model: {
				name: "",
				username: ""
			},
			addrole: {
				rolename: "",
				perm_name: ""
			},
			checkedPerm_Id: [],
			rolenameError : '',
			permissionError : '',
		};
	},

	created: function() {},
	mounted() {
		this.pageno = 0;
		this.getRoleData();
	},
	methods: {
		castInteger(val){
			 return Number(val);
		},
		addNewRole() {
			this.roleaction = "add";
			this.addrolemodal = true;
			this.permissionFlag = false;
			this.addrole.rolename = '';
			this.checkedPerm_Id = [];
			this.$validator.reset();
			this.errors.clear();
		},
		closeAddRoleModal() {
			this.addrolemodal = false;
			this.errors.clear();
			this.getRoleData()
		},

		closeEditRoleModal() {
			this.addrolemodal = false;
			this.$validator.reset();
			this.errors.clear();		
			this.resetform();
		},
		resetform() {
			this.totalRows=0;
			this.rolename = '';
			this.devicetype = '';
			this.listPermissionData = [];
			document.getElementById('rolename').value='';
			this.checkedPerm_Id = [];
			this.getRoleData();
		},
		getPermissionList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = {
				'devicetype': this.devicetype
			};
			axios({
				method: "POST",
				url: apiUrl.api_url + "permissionmaster",
				data: this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			}).then(
				result => {
					this.permissionFlag = true;
					this.permissionError = "";
					this.listPermissionData = result.data.data;
				},
				error => {
					console.error(error);
				}
			);
		},
		getRoleDataSearch(){
			this.currentPage =1;
			this.getRoleData();
		},
		getRoleData() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.input = {
				offset:(this.currentPage - 1) * 10,
				limit: 10,
				rolename: this.rolename
				// roleid: this.roleid,
			};
			this.isLoading = true;
			axios({
				method: "POST",
				url: apiUrl.api_url + "roleMaster",
				data: this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			}).then(
				result => {
					this.listRoleData = result.data.rows;
					this.isLoading = false;
					this.totalRows = result.data.count;
					this.resultCount = result.data.count
					if (this.totalRows < 10) {
						this.totalPage = 1;
					} else {
						this.totalPage = Math.ceil(this.totalRows / 10);
					}
				},
				error => {
					console.error(error);
				}
			);
		},

		saveRole() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			if(this.addrole.rolename.trim() == "")
			{
				this.rolenameError = this.$t('roles.AddRolesError');
				 return false;
			}
			else {
				 this.rolenameError = "";
			}
			if(this.checkedPerm_Id.length == 0)
			{
				this.permissionError = this.$t('roles.permissionError');
				return false;
			}
			else {
				 this.permissionError = "";
			}


			var actualIds = [];
			var tempArray = [];
			var previousValueInt = 0;
			var previousValue = '';
			var curentValueInt = 0;
			var curentValue = 0 ;
      for(var i=0 ; i < this.checkedPerm_Id.length;i++)
			{

				   if(i==0)
					 {
						  previousValueInt = this.checkedPerm_Id[i];
							if(this.checkedPerm_Id.length == 1)
							{
									actualIds.push({
										permissionid : previousValueInt,
										innerrole : tempArray
								 });
							}

					 }
					 else if (i == this.checkedPerm_Id.length-1) {

					    if(typeof(this.checkedPerm_Id[i]) == 'number')
							{
								actualIds.push({
									 permissionid : previousValueInt,
									 innerrole : tempArray
								});
								tempArray = [];
								actualIds.push({
									 permissionid : this.checkedPerm_Id[i],
									 innerrole : tempArray
								});

							}
							else {
								curentValue = this.checkedPerm_Id[i];
								var temp = curentValue.split("_");

								 tempArray.push({
									id : temp[0],
								});

								actualIds.push({
									 permissionid : previousValueInt,
									 innerrole : tempArray
								});
								curentValue = '';
								tempArray =[];
							}
					 }
					 else {

              if(typeof(this.checkedPerm_Id[i]) == 'number')
							{
								  // if(typeof(curentValue) == 'number')
									// {
										  actualIds.push({
											   permissionid : previousValueInt,
												 innerrole : tempArray
											});
											previousValueInt = this.checkedPerm_Id[i];
											curentValue = '';
											tempArray =[];
									// }
							}
							else {
								curentValue = this.checkedPerm_Id[i];
								var temp = curentValue.split("_");

								tempArray.push({
								 id : temp[0],
							 });
								 //previousValue = curentValue;
								 curentValue = '';
							}
					 }
			}

			//console.log(actualIds);return false;
			//this.isLoading = true;

			axios({
					method: "POST",
					url: apiUrl.api_url + "SubmitRoleData",
					data: {
						rolename: this.addrole.rolename,
						permissionid: actualIds
					},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(response => {
					if (response.data.msg == 200) {
						this.$alertify.success("Role Created Successfully");
						this.addrolemodal = false;
						this.resetform();
						this.getRoleData();
					} else if (response.data.msg == 209) {
						this.$alertify.error("Role Already Exist");
						this.addrolemodal = false;
					} else if (response.data.msg == 400) {
						this.$alertify.error("Failed");
						this.addrolemodal = false;
					}
					this.isLoading = false;
				})
				.catch(httpException => {
					console.error("exception is:::::::::", httpException);
				});
		},

		getRoleRowData(data) {
			this.permissionflag = false;
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.$validator.reset();			
			this.errors.clear();  
			// this.rolename = data.rolename;       
			document.getElementById('rolename').value=data.rolename;
			this.roleaction = "edit";
			this.addrolemodal = true;
			this.checkedPerm_Id = [];
			let tempthis = this;

			axios({
				method: "POST",
				url: apiUrl.api_url + "getRolePermissionData",
				data: {
					roleid: data.roleid
				},
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			}).then(
				result => {
					this.permissionid = result.data;
					// result.data.forEach(function(value) {
					// 	//by using tempthis variable we provided the current access to the checkedPerm_Id array which not accessible from out of the function which is getRoleRowData
					// 	tempthis.checkedPerm_Id.push(value.permissionid);
          // });

					for(var i=0; i<result.data.length; i++)
					{
						 tempthis.checkedPerm_Id.push(result.data[i].permissionid);
						  var temp = JSON.stringify(result.data[i].innerpermission);

						  if(temp!== 'null')
							{
                 var propertyValues = Object.values(result.data[i].innerpermission);
								 //console.log(propertyValues.length);
								 for(var j=0; j< propertyValues.length; j++)
									{
										  tempthis.checkedPerm_Id.push(propertyValues[j].id+'_'+result.data[i].permissionid);
									}
							}
					}
				},
				error => {
					console.error(error);
				}
			);
			this.addrole = data;
		},

		editRole() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			if(this.addrole.rolename.trim() == "")
			{
				 this.rolenameError = this.$t('roles.AddRolesError');
				 return false;
			}
			else {
				 this.rolenameError = "";
			}

			if(this.checkedPerm_Id.length == 0)
			{
				this.permissionError = "Permissions Is Required";
				return false;
			}
			else {
				 this.permissionError = "";
			}

			var finalArr = [];
      for(var i=0 ; i < this.checkedPerm_Id.length;i++)
			{
          if(i == 0)
					{
						 finalArr.push(this.checkedPerm_Id[i]);

						 //Now checking whether is componet exists in array
						 for(var j=0 ; j < this.checkedPerm_Id.length;j++)
						 {
                if(typeof(this.checkedPerm_Id[j]) === 'number')
								{
									 continue;
								}
								else {
									var temp = this.checkedPerm_Id[j].split("_");
									if(temp[1] == this.checkedPerm_Id[i])
									{
										  finalArr.push(temp[0]);
									}
								}
						 }//end j loop
					}
					else {

						//checking whether the newxt value is number or string
						if(typeof(this.checkedPerm_Id[i]) === 'number')
						{
							 finalArr.push(this.checkedPerm_Id[i]);
							 //Now checking whether is componet exists in array
							 for(var j=0 ; j < this.checkedPerm_Id.length;j++)
							 {
	                if(typeof(this.checkedPerm_Id[j]) === 'number')
									{
										 continue;
									}
									else {
										var temp = this.checkedPerm_Id[j].split("_");
										if(temp[1] == this.checkedPerm_Id[i])
										{
											  finalArr.push(temp[0]);
										}
									}
							 }//end j loop
						}

					}
			}
		  //console.log(this.checkedPerm_Id);

			//var permissionid = this.checkedPerm_Id.map(Number);
			this.checkedPerm_Id = finalArr;
			var actualIds = [];
			var tempArray = [];
			var previousValueInt = 0;
			var previousValue = '';
			var curentValueInt = 0;
			var curentValue = 0 ;
      for(var i=0 ; i < this.checkedPerm_Id.length;i++)
			{

				   if(i==0)
					 {
						  previousValueInt = this.checkedPerm_Id[i];
							if(this.checkedPerm_Id.length == 1)
							{
									actualIds.push({
										permissionid : previousValueInt,
										innerrole : tempArray
								 });
							}
					 }
					 else if (i == this.checkedPerm_Id.length-1) {

					    if(typeof(this.checkedPerm_Id[i]) == 'number')
							{
								actualIds.push({
									 permissionid : previousValueInt,
									 innerrole : tempArray
								});
								tempArray = [];
								actualIds.push({
									 permissionid : this.checkedPerm_Id[i],
									 innerrole : tempArray
								});

							}
							else {
								curentValue = this.checkedPerm_Id[i];
								 tempArray.push({
									id : curentValue,
								});

								actualIds.push({
									 permissionid : previousValueInt,
									 innerrole : tempArray
								});
								curentValue = '';
								tempArray =[];
							}
					 }
					 else {

              if(typeof(this.checkedPerm_Id[i]) == 'number')
							{
								  // if(typeof(curentValue) == 'number')
									// {
										  actualIds.push({
											   permissionid : previousValueInt,
												 innerrole : tempArray
											});
											previousValueInt = this.checkedPerm_Id[i];
											curentValue = '';
											tempArray =[];
									// }
							}
							else {
								curentValue = this.checkedPerm_Id[i];
                 tempArray.push({
									 "id" : curentValue,
								 });
								 //previousValue = curentValue;
								 curentValue = '';
							}
					 }
			}
			// console.log(actualIds);
			// return false;

			this.isLoading = true;
			axios({
					method: "POST",
					url: apiUrl.api_url + "UpdateRole",
					data: {
						rolename: this.addrole.rolename,
						roleid: this.addrole.roleid,
						permissionid: actualIds
					},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(response => {
					if (response.data.msg == 200) {
						this.$alertify.success("Roles updated successfully");
						this.addrolemodal = false;
					} else {
						this.$alertify.error("Roles failed to update");
						this.addrolemodal = false;
					}
					this.isLoading = false;
				})
				.catch(httpException => {
					console.error("exception is:::::::::", httpException);
				});
		},

		// getPaginationData(currentPage) {
		// 	this.pageno = (currentPage - 1) * 10;
		// 	this.getRoleData();
		// },
		onPageChange(page) {
		  this.currentPage = page;
		  this.getRoleData()
		},
		onSubmit: function(event) {
			this.$validator.validateAll().then(() => {
				console.log('form is valid', this.model);
				event.target.reset();
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		}
	}
};



// WEBPACK FOOTER //
// ./src/views/components/role/role.component.js